import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../services/AuthContext";

function Home() {
  const navigate = useNavigate();
  const { auth } = useAuth(); // Get auth status from AuthContext

  const offersRef = useRef(null); // Create a ref for the "What PiggyMate Offers" section

  const handleButtonClick = () => {
    if (auth) {
      navigate("/landingpage");
    } else {
      navigate("/login");
    }
  };

  const handleScroll = () => {
    if (offersRef.current) {
      offersRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <header
        className="bg-gradient-to-r from-purple-600 to-indigo-600 text-white w-full py-6 shadow-md"
        style={{
          // backgroundColor: "rgb(251, 217, 255)",
          padding: "30px"
        }}
      >
        <img
          src="../../piggylogo.ico"
          alt="Piggymate Website Header"
          style={{ height: "20%", width: "20%" }}
        />
        <h2
          className="text-center mt-2 oldFontBoldClass"
          style={{ color: "black", letterSpacing: "0px" }}
        >
          Help your kids learn to be wise with their finances!
        </h2>
      </header>
      <br />
      <hr
        style={{
          width: "70%",
          margin: "0 auto",
          display: "block",
          height: "1px",
          border: "none",
          borderRadius: "20px",
          backgroundColor: "black",
          borderStyle: "solid",
          opacity: "20%"
        }}
      />
      <br />
      <br />

      {/* #4caf4f */}

      <button
        className="job-complete-button globalButton"
        style={{ width: "25%", fontSize: "x-large" }}
        onClick={handleButtonClick}
      >
        {auth ? "Go to Dashboard" : "Start Saving Now!"}
        <span className="ml-2">&#8594;</span>
      </button>
      <br />
      <br ref={offersRef} />

      <div className="max-w-4xl text-center">
        <p className="HomePageFeatureText">
          In an increasingly digital world, this is your solution to keeping
          track of your children's piggy bank money. <br></br> We hope to help
          you practice and teach good practices to set your kids up for
          financial success in the future.
        </p>
        <br />
      </div>

      {/* Change the header to a button that triggers the scroll */}
      <div className="centerTheMenuButtons">
        <button
          className="AnnouncementButton"
          onClick={handleScroll} // Trigger scroll
        >
          What PiggyMate Offers
        </button>
      </div>

      {/* Section you want to scroll to */}
      <div className="HomePageContainer">
        <div className="HomePageFeatureBox">
          <h2>1. Savings</h2>
          <p className="HomePageFeatureText">
            Help your kids learn to make and achieve their savings goals
          </p>
        </div>
        <div className="HomePageFeatureBox">
          <h2>2. Jobs</h2>
          <p className="HomePageFeatureText">
            Encourage hard work and responsibility by creating jobs your kids
            can complete to earn money
          </p>
        </div>
        <div className="HomePageFeatureBox">
          <h2>3. Investing</h2>
          <p className="HomePageFeatureText">
            Show your kids how saving can grow their money through interest
          </p>
        </div>
        <div className="HomePageFeatureBox">
          <h2>4. Lessons</h2>
          <p className="HomePageFeatureText">
            Introduce new financial vocabulary and smart money habits with our
            engaging lesson videos
          </p>
        </div>
      </div>
    </>
  );
}

export default Home;
